export class PathDoesNotExistError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'PathDoesNotExistError';
    }
}


